import { Component, Directive, Input, TemplateRef } from "@angular/core";

@Component({
    selector: 'exa-footer',
    template: '<ng-content></ng-content>'
})
export class ExaFooter { }

@Component({
    selector: 'exa-header',
    template: '<ng-content></ng-content>'
})
export class ExaHeader { }

@Directive({
    selector: '[exaTemplate]',
    host: {
    }
})
export class ExaTemplate {

    @Input() type: string;

    @Input('exaTemplate') name: string;

    constructor(public template: TemplateRef<any>) { }

    getType(): string {
        return this.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/exa/common/shared.ts